import styled from 'styled-components';

export const MenuWrapper = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  width: 0;
  height: calc(100vh - 50px);
  z-index: 1;
  transition: all 0.3s ease-out;
  &.open {
    width: 258px;
  }

  &.wide {
    width: 483px;
  }

  &.dark {
    /* background: #333E4EB3; */
    background: #292638;
  }
`;

export const ToggleWrapper =  styled.div`
  width: 20px;
  height: 20px;
  position: relative;
  left: -70px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #201D2F;

  border-radius: 2px;

  /* transform: rotate(180deg); */
  transition: transform .3s ease-out;
  top: 5px;

  .open & {
    transform: rotate(180deg);
    right: -283px
    ;
  }

  & svg {
    fill: #f0f0f5;
    margin: 0 auto;
    text-align: center;
  }
`;

export const WidgetsWrapper = styled.div`
  background: #29263880;

  width: 237px;
`;

export const ContentWrapper = styled.div`
  visibility: hidden;
  height: 100%;
  margin-top: -20px;

  .open & {
    visibility: unset;
  }

  & .MyAwesomeScrollbarsWrapper {
    inset: 0 !important;
  }

  & .ScrollbarsCustom-Thumb.ScrollbarsCustom-ThumbY {
    background-color: #424252 !important;
  }
`;

export const InnerWrapper = styled.div`
  padding-top: 5px;
  padding-right: 11px;
  padding-left: 10px;
  background: #333E4E80;
  backdrop-filter: blur(15px);
`;

export const AllWrapper = styled.div`
  display: flex;
  height: calc(100vh - 55px);
  .open & {
    width: 258px;
  }

  .open.wide & {
    width: 483px;
  }
`;
